export default __webpack_public_path__ + "static/img1-2bc9f29343c293385b3d171b82cb6857.png";